const horizontal_16 = require("assets/v1.1/icons/Navigation/Overflow/horizontal_16.svg");
const horizontal_24 = require("assets/v1.1/icons/Navigation/Overflow/horizontal_24.svg");

export const Overflow = {
  16: horizontal_16,
  24: horizontal_24,
};
